import { render, staticRenderFns } from "./ShareAlertComponent.vue?vue&type=template&id=6c1465fc"
import script from "./ShareAlertComponent.vue?vue&type=script&lang=js"
export * from "./ShareAlertComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports